import ahoy from './ahoy'
import { getMetaValue } from '../utils'

if (getMetaValue('ahoy')) {
}
ahoy.trackClicks()
